/**
 * Base state for current module
 */
const state = {
  banner: null,
  props: {},
  defaultProps: [
    {
      key: "banner",
      label: "Banner",
      helperText: "Select the banner you wish to display",
      type: "component",
      componentName: "announcement-banner-select",
      value: null,
      validation: "required:true",
    },
  ],
  propOptions: {},
  admin: true,
};

export default state;
